<mat-toolbar>
  Clasificar
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="reload()"><mat-icon color="primary">refresh</mat-icon></button>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field  class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
    <mat-form-field class="searchMobile">
      <mat-label>Clasificado</mat-label>
      <mat-select [(value)]="clasificado" (selectionChange)="onClasificadoChange()">
        <mat-option value="all">Todos</mat-option>
        <mat-option value="true">Clasificado</mat-option>
        <mat-option value="false">Sin clasificar</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="fechaFin" matSortDirection="desc" (matSortChange)="onSortChange($event)">
      <ng-container matColumnDef="albaran">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Albarán </th>
        <td mat-cell *matCellDef="let element"> {{element.albaran}} </td>
      </ng-container>
      <ng-container matColumnDef="fechaFin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
        <td mat-cell *matCellDef="let element"> {{element.fechaFin}} </td>
      </ng-container>
      <ng-container matColumnDef="clasificado">
        <th mat-header-cell *matHeaderCellDef > Clasificar </th>
        <td mat-cell *matCellDef="let element">
          <button mat-mini-fab color="primary" (click)="verRegistro(element.albaran)"><mat-icon>play_circle_outline</mat-icon></button>
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="3">No existen registros...<br></td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator
    [length]="totalRecords"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pages"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>
</div>
